const state = {
    workCodeInformationFields: [
        // {
        //     key: "code",
        //     label: "工單編號",
        //     sortable: false,
        //     class: "font-family-dfyuanstd-w5 table-col-hight"
        // },
        {
            key: "work_org_code",
            label: "工單編號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "productCode",
            label: "料號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "control_card",
            label: "管制卡號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "product_chinese_name",
            label: "料名",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    workCodeInformationItem: [],
}
const getters = {
    get_workCodeInformationFields: state => {
        return state.workCodeInformationFields
    },
    get_workCodeInformationItem: state => {
        return state.workCodeInformationItem
    },
}
const actions = {
    set_workCodeInformationFields(context, array) {
        context.commit('SET_WORKCODEINFORMATIONFIELDS', array);
    },
    set_workCodeInformationItem(context, array) {
        context.commit('SET_WORKCODEINFORMATIONITEM', array);
    },
    clear_workCodeInformationItem(context) {
        context.commit('CLEAR_WORKCODEINFORMATIONITEM');
    },
}
const mutations = {
    SET_WORKCODEINFORMATIONFIELDS(state, array) {
        state.workCodeInformationFields = array;
    },
    SET_WORKCODEINFORMATIONITEM(state, array) {
        state.workCodeInformationItem = array;
    },
    CLEAR_WORKCODEINFORMATIONITEM(state) {
        state.workCodeInformationItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/workCodeInformation.js